import { getLocale } from '@v4/common/utils/locale';
import { COMPARE_PAGE } from '@v4/compare/config';
import { getQueryParams, stringifyQueryParams } from '@v4/common/utils/url';

/**
 * Build compare page URI
 */
export const buildComparePageURI = (vehicles = []) => {
    if (!Array.isArray(vehicles)) {
        throw new Error('Vehicles list must be an array');
    }
    const uri = [COMPARE_PAGE[getLocale()]];
    vehicles.forEach((vehicle) => {
        uri.push(`${vehicle.make}-${vehicle.model}`);
    });
    const vehicleIds = vehicles.map((v) => v.vehicleHistoricalId);
    const q = getQueryParams() || {};

    if (vehicleIds.length && vehicleIds.filter((v) => v).length) {
        q.vehicleHistoricalId = vehicleIds.join('|');
    } else {
        Reflect.deleteProperty(q, 'vehicleHistoricalId');
    }
    return `${uri.join('/')}${stringifyQueryParams(q, { encode: true })}`;
};
